module.exports = __webpack_public_path__ + "img/target-1.6cf2127b.jpg";